import { styled } from '@mui/material/styles'

export const DropdownContainer = styled('div')`
  position: relative;
  display: inline-block;
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  border-bottom-left-radius: ${({ show }) => (show ? '0px' : '8px')};
  border-bottom-right-radius: ${({ show }) => (show ? '0px' : '8px')};
  box-sizing: border-box;
  border: ${({ show, theme }) => (show ? `2px solid ${theme.colors.blue.shades.shade600}` : `2px solid ${theme.colors.neutral.shades.shade600}`)};`;

export const DropdownList = styled('div')`
  display: block;
`;

export const DropdownListContent = styled('div')`
  width: 100%;
  min-width: 160px;
  box-sizing: border-box;
  display: ${({ show }) => (show ? 'block' : 'none')};
  border: ${({ show, theme }) => (show ? `2px solid ${theme.colors.blue.shades.shade600}` : `2px solid ${theme.colors.neutral.shades.shade600}`)};
  border-top: none;
  position: absolute;
  z-index: 1;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  max-height: 300px;
  overflow-y: auto;
  box-sizing: border-box;
`;

export const Item = styled('div')`
  padding: 8px 16px;
  color: ${({ theme }) => theme.colors.neutral.shades.shade700};
  font-family: nunito-sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  box-sizing: border-box;
`;

export const SelectedItemsWrapper = styled('div')`
  display: flex;
  flex-wrap: wrap;
  padding: 16px 8px;
  box-sizing: border-box;
`;

export const SelectedList = styled('ul')`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  margin: 0;
  list-style: none;
  padding: 0;
  /* Custom dropdown arrow (optional) */
  background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23333' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpath d='M6 9l6 6 6-6'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: right 8px center;
  background-size: 16px;
  box-sizing: border-box;
`;

export const SelectedItem = styled('li')`
  padding: 0px 10px;
  margin-right: 2px;
  border-radius: 5px;
  color: ${({ theme }) => theme.colors.neutral.shades.shade700};
  font-family: nunito-sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  min-width: fit-content;
  box-sizing: border-box;
  background-color: ${({ theme }) => theme.colors.neutral.shades.shade100};
`;

export const CloseIcon = styled('button')`
  width: 20px;
  height: 20px;
  background: none;
  color: inherit;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  margin-top: -2px;
`;

export const SelectPlaceholder = styled('li')`
  color: ${({ theme }) => theme.colors.neutral.shades.shade600}};
  font-family: nunito-sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  background-color: ${({ theme }) => theme.colors.white}};
  border: none;
`;

export const MultiSelectDropdownLabel = styled('div')`
  color: ${({ theme }) => theme.colors.neutral.shades.shade600}};
  font-family: nunito-sans;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: 24px;
  margin-bottom: 8px;
`;